// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        if (!document.querySelectorAll('.degrees').length) {
            return;
        }

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        const originalResultsCount = document.querySelectorAll('.degrees__result').length;

        let filters = {
            s: params.s,
            'search-major': false,
            'search-minor': false,
            'search-graduate': false,
            'search-campus': false,
            'search-online': false,
            areas: []
        };

        const defaultFilters = { ...filters };

        $('.degrees__form-filters-label > a').on('click', function (e) {
            e.preventDefault();

            const closest = $(this).closest('[data-open]');
            closest.attr('data-open', closest.attr('data-open') != "true");
        });

        $('.degrees__results-grid > button').on('click', function (e) {
            e.preventDefault();

            const closest = $(this).closest('[data-view]');
            closest.attr('data-view', closest.attr('data-view') == "grid" ? 'list' : 'grid');
        });

        document.querySelectorAll('.degrees__form-filters-clear, .degrees__results-filters-clear').forEach($el => $el.addEventListener('click', e => {
            e.preventDefault();

            searchRecords(defaultFilters);
        }));

        document.querySelectorAll('.degrees__form-filters-boxes input, .degrees__form-filters-boxes-mobile input').forEach($el => $el.addEventListener('change', (e) => {

            const value = e.target.checked ? 1 : 0;
            const key = e.target.getAttribute('name');

            filters[key] = value;

            searchRecords(filters);

        }));

        document.querySelectorAll('.degrees__results-filter').forEach($el => $el.addEventListener('click', (e) => {
            e.preventDefault();

            const key = $el.getAttribute('data-filter');

            filters[key] = false;

            searchRecords(filters);

        }));

        const $title = document.querySelector('.degrees__results-title');
        const $typeFilter = document.querySelector('.degrees__results-filter[data-type="search"]');

        function searchRecords(updatedFilters) {
            Object.keys({ ...updatedFilters }).forEach(f => {
                filters[f] = updatedFilters[f];
            });

            $typeFilter.querySelector('span').textContent = 'Text Search: ' + filters.s;

            document.querySelectorAll('.degrees__result').forEach($el => {
                let matches = true;

                if (matches && filters.s && -1 == $el.dataset.search.toLowerCase().indexOf(filters.s.toLowerCase())) {
                    matches = false;
                }

                if (matches && (!!filters['search-graduate'] || !!filters['search-major'] || !!filters['search-minor'])) {
                    let degreeTypeFound = false;
                    if (!!filters['search-graduate'] && $el.dataset.programType == 'graduate') {
                        degreeTypeFound = true;
                    }

                    if (!!filters['search-major'] && $el.dataset.programType == 'major') {
                        degreeTypeFound = true;
                    }

                    if (matches && !!filters['search-minor'] && $el.dataset.programType == 'minor') {
                        degreeTypeFound = true;
                    }

                    if (!degreeTypeFound) {
                        matches = false;
                    }
                }

                if (matches && (!!filters['search-online'] || !!filters['search-campus'])) {
                    let degreeLocationFound = false;
                    if (!!filters['search-online'] && $el.dataset.programLocation.split(',').indexOf('online') >= 0) {
                        degreeLocationFound = true;
                    }

                    if (!!filters['search-campus'] && $el.dataset.programLocation.split(',').indexOf('campus') >= 0) {
                        degreeLocationFound = true;
                    }

                    if (!degreeLocationFound) {
                        matches = false;
                    }
                }

                // This will search for articles that match $el.dataset.area (the blog articles) against selected filters.
                if (matches && filters.areas.length) {
                    let areaFound = false;
                    filters.areas.forEach(a => {
                        // $el.dataset.area.match(new RegExp("(?:^|\\s*,\\s*)"+a+"(?:\\s*,\\s*|$)")) will search for the matching string in comma separated values 
                        if (($el.dataset.area == a) || $el.dataset.area.match(new RegExp("(?:^|\\s*,\\s*)"+a+"(?:\\s*,\\s*|$)"))) {
                          //  console.log("Matched Data Set: " + $el.dataset.area);
                            areaFound = true;

                        }
                    });

                    if (!areaFound) {
                        matches = false;
                    }
                }

                $el.setAttribute('data-visible', matches);
            });

            const resultsCount = document.querySelectorAll('.degrees__result[data-visible="true"]').length;
            $title.querySelector('span').textContent = (resultsCount == originalResultsCount) ? "All Programs" : resultsCount + " Program" + (resultsCount != 1 ? "s" : "");

            $typeFilter.style.display = !filters.s ? 'none' : 'flex';

            $('.degrees__results-filters-list button[data-type="filter"]').remove();
            let hasFilters = !!filters.s;

            let addedFilters = [];
            Object.keys(filters).forEach(f => {

                if (f != 's' && f != 'areas' && !!filters[f] && !addedFilters.includes(f)) {
                    hasFilters = true;
                    addedFilters.push(f);

                    $(`<button class="degrees__results-filter" data-type="filter" data-filter="${f}">
						<span>${$('[name="' + f + '"]').first().parent().find('em').text()}</span>
						<i class="fa-solid fa-xmark"></i>
					</button>`).appendTo('.degrees__results-filters-list')
                }
            });

            $('.degrees__results-filters-list button[data-type="area"]').remove();
            $('.degrees__form-filters-area').attr('data-selected', 'false');
            filters.areas.forEach(a => {
                //console.log(a);
                hasFilters = true;


                $('.degrees__form-filters-area[data-area="' + a + '"]').attr('data-selected', 'true');
                $(`<button class="degrees__results-filter" data-type="area" data-area-filter="${a}">
						<span>${a}</span>
						<i class="fa-solid fa-xmark"></i>
					</button>`).appendTo('.degrees__results-filters-list')
            })

            document.querySelector('.degrees__results-filters').setAttribute('data-has-results', hasFilters);
            document.querySelector('.degrees__form input').value = filters.s;
            document.querySelectorAll('.degrees__form-filters-boxes input, .degrees__form-filters-boxes-mobile input').forEach($el => {
                $el.checked = filters[$el.getAttribute('name')];
                $el.parentNode.setAttribute('data-checked', $el.checked);
            });
            document.querySelectorAll('.degrees__results-filter[data-type="filter"]').forEach($el => $el.addEventListener('click', e => {
                const filter = $el.getAttribute('data-filter');
                const filters = {};
                filters[filter] = false;
                searchRecords(filters);
            }));
            document.querySelectorAll('.degrees__results-filter[data-type="area"]').forEach($el => $el.addEventListener('click', e => {
                const area = $el.getAttribute('data-area-filter');
                const areas = [...filters.areas].filter(f => f != area);
                searchRecords({ areas });
            }));
        }

        let typeTimer = null;
        document.querySelector('.degrees__form input').addEventListener('keyup', e => {
            const term = e.target.value;

            if (term.length < 4 && term.length > 0) {
                return;
            }

            if (typeTimer) {
                clearTimeout(typeTimer);
            }

            typeTimer = setTimeout(() => {
                searchRecords({ s: term });
            }, 300);
        });

        document.querySelector('.degrees__results-filters-clear').addEventListener('click', e => {
            e.preventDefault();
            searchRecords({ s: '' });
        });

        document.querySelector('.degrees__results-filter[data-type="search"]').addEventListener('click', e => {
            e.preventDefault();
            searchRecords({ s: '' });
        });

        document.querySelectorAll('.degrees__form-filters-area').forEach($el => $el.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();

            const area = $el.dataset.area;
            $el.setAttribute('data-selected', $el.dataset.selected != "true");
            const existingIndex = filters.areas.indexOf(area);

            if (existingIndex == -1) {
                searchRecords({ areas: [...filters.areas, area] });
                console.log({ areas: [...filters.areas, area] });
            }
            else {
                let newRecords = [...filters.areas];
                newRecords.splice(existingIndex, 1);
                // console.log('Areas of Study: ' + { areas: newRecords });
                searchRecords({ areas: newRecords });
            }
        }));

        const $areasButton = document.querySelector('.degrees__form-filters-areasbutton');
        $areasButton.addEventListener('click', e => {
            const $parent = $areasButton.parentNode.parentNode.parentNode;
            $parent.setAttribute('data-areas-open', $parent.getAttribute('data-areas-open') != 'true');
        });

        const $areasButtonMobile = document.querySelector('.degrees__form-filters-areasbutton-mobile');
        $areasButtonMobile.addEventListener('click', e => {
            const $parent = $areasButtonMobile.parentNode;
            $parent.setAttribute('data-areas-open', $parent.getAttribute('data-areas-open') != 'true');
        });

    }, false);

})(jQuery);